/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2025 Rochester Software Associates (service@rocsoft.com)
 */

/**
 * A hidden div used as a child that extends the boundaries of the parent div so that it takes longer for your mouse to exit the parent div.
 * This is useful for popup menus. Your mouse will look like it's outside the menu, but it's still over this hidden div that is below it.
 * So the menu remains open because there is this "buffer zone" around it and it's not so easily closed by moving your mouse too far.
 *
 * The buffer zone extends 30px outside of the parent div on all sides from the CSS. It is placed below everything with a zero
 * z-index so your mouse can interact with everything. Think of it as a placemat below your plate (menu).
 *
 * @returns {React.ReactNode} a hidden div
 */
const ActiveBufferZone = () => {
    return (
        <div className="active-buffer-zone"></div>
    );
};

export default ActiveBufferZone;